// Workaround oficial de CVE-2024-4367 (GHSA-wgrm-67xf-hhpq): con `isEvalSupported` a true, que es el
// valor por defecto, un PDF malicioso ejecuta JavaScript en el dominio de la app. Afecta a
// pdfjs-dist <= 4.1.392 y react-pdf 5 trae la 2.12.313. Se podrá quitar al subir react-pdf a
// 7.7.3 o superior (TAN-10849); hasta entonces, cada `<Document>` debe recibirlo (TAN-11490).
export const PDF_DOCUMENT_OPTIONS = Object.freeze({ isEvalSupported: false });
